import { WithStyles, withStyles } from '@core/theme/utils/with-styles';

import styles from './RequirementDocument.styles';

export type RequirementDocumentIconProps = WithStyles<typeof styles>;

const RequirementDocumentIconComponent: React.FC<RequirementDocumentIconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="35" viewBox="0 0 212 119" width="auto">
      <g fill="none" fillRule="evenodd" transform="translate(-3 -3)">
        <g
          stroke="#d9dde4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          transform="matrix(.70710678 .70710678 -.70710678 .70710678 194.646447 .368272)"
        >
          <path d="m.6 5.5h10.8" />
          <path d="m6 0v11" />
        </g>
        <g
          stroke="#d9dde4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          transform="matrix(.70710678 .70710678 -.70710678 .70710678 8.646447 68.368272)"
        >
          <path d="m.6 5.5h10.8" />
          <path d="m6 0v11" />
        </g>
        <circle cx="14" cy="21" r="5" stroke="#d9dde4" strokeWidth="2" />
        <circle cx="210.5" cy="99.5" r="3.5" stroke="#d9dde4" strokeWidth="2" />
        <g transform="translate(23 8)">
          <path
            d="m130.201475 93.0322581h-112.9430956c-2.2115421 0-4.0034774-1.7927316-4.0034774-4.0041084v-85.16824131c0-2.13229936 1.7277382-3.85990839 3.860197-3.85990839h113.086376c2.211542 0 4.004407 1.79273161 4.004407 4.00410839v85.02404131c0 2.2113768-1.792865 4.0041084-4.004407 4.0041084"
            fill="#fff"
          />
          <path
            d="m130.201475 93.0322581h-112.9430956c-2.2115421 0-4.0034774-1.7927316-4.0034774-4.0041084v-85.16824131c0-2.13229936 1.7277382-3.85990839 3.860197-3.85990839h113.086376c2.211542 0 4.004407 1.79273161 4.004407 4.00410839v85.02404131c0 2.2113768-1.792865 4.0041084-4.004407 4.0041084z"
            stroke="#bfc5d1"
            strokeWidth="1.5"
          />
          <path
            d="m127.376573 80.5725806h-107.2914361c-1.0269691 0-1.8596467-.8252583-1.8596467-1.8451271v-71.89845536c0-1.01895083.8326776-1.84512717 1.8596467-1.84512717h107.2914361c1.026044 0 1.858721.82617634 1.858721 1.84512717v71.89845536c0 1.0198688-.832677 1.8451271-1.858721 1.8451271"
            fill="#fff"
          />
          <path
            d="m127.376573 80.5725806h-107.2914361c-1.0269691 0-1.8596467-.8252583-1.8596467-1.8451271v-71.89845536c0-1.01895083.8326776-1.84512717 1.8596467-1.84512717h107.2914361c1.026044 0 1.858721.82617634 1.858721 1.84512717v71.89845536c0 1.0198688-.832677 1.8451271-1.858721 1.8451271z"
            stroke="#bfc5d1"
            strokeWidth="1.5"
          />
          <path
            d="m139.893549 93.0322581h-134.81680961c-.86981566 0-1.69069264-.4149073-2.21239736-1.1195021l-2.49125546-3.3613094c-.91413748-1.2335081-.04432182-2.994995 1.48016401-2.994995h141.27486842c1.518945 0 2.386914 1.7558801 1.475547 2.9856502l-2.497719 3.3706542c-.522628.7045948-1.342582 1.1195021-2.212398 1.1195021"
            fill="#fff"
          />
          <path
            d="m139.893549 93.0322581h-134.81680961c-.86981566 0-1.69069264-.4149073-2.21239736-1.1195021l-2.49125546-3.3613094c-.91413748-1.2335081-.04432182-2.994995 1.48016401-2.994995h141.27486842c1.518945 0 2.386914 1.7558801 1.475547 2.9856502l-2.497719 3.3706542c-.522628.7045948-1.342582 1.1195021-2.212398 1.1195021z"
            stroke="#bfc5d1"
            strokeLinejoin="bevel"
            strokeWidth="1.5"
          />
        </g>
        <g stroke="#324DFD" strokeWidth="1.5">
          <path
            d="m63.5529609 71c-4.6725918 3.019066-12.0491664 10.4199072-11.52664 26.9118995.6696011 21.1224505 33.234323 33.4042675 43.391615 11.6229455 6.6777411-14.318999-14.1593691-16.7470989-10.1993133-.950685 3.0912362 12.32863 17.0899934 17.232523 30.7813774 5.651251"
            strokeDasharray="4 8"
            strokeLinecap="round"
          />
          <rect fill="#fff" height="81.5" rx="5" width="63.5" x="125.75" y="29.75" />
          <path
            d="m148 25.75c-1.242641 0-2.25 1.0073593-2.25 2.25v6c0 1.2426407 1.007359 2.25 2.25 2.25h19c1.242641 0 2.25-1.0073593 2.25-2.25v-6c0-1.2426407-1.007359-2.25-2.25-2.25z"
            fill="#fff"
          />
          <g strokeLinecap="round" strokeLinejoin="round" transform="translate(136 48)">
            <path d="m7 0-4.8125 5-2.1875-2.27272727" />
            <path d="m15.2745098 3h27.2254902" />
          </g>
          <g strokeLinecap="round" strokeLinejoin="round" transform="translate(136 62.666667)">
            <path d="m7 0-4.8125 5-2.1875-2.27272727" />
            <path d="m15.2745098 3h27.2254902" />
          </g>
          <g strokeLinecap="round" strokeLinejoin="round" transform="translate(136 77.333333)">
            <path d="m7 0-4.8125 5-2.1875-2.27272727" />
            <path d="m15.2745098 3h27.6532246" />
          </g>
          <g strokeLinecap="round" strokeLinejoin="round" transform="translate(136 92)">
            <path d="m7 0-4.8125 5-2.1875-2.27272727" />
            <path d="m15.2745098 3h27.8915058" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RequirementDocumentImage = withStyles(styles)(RequirementDocumentIconComponent);
